import axios from 'axios'
import {
    ConfigurationPersonnelProcedureAssignmentCreateRequest,
    ConfigurationPersonnelProcedureAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-procedure-assignment/configuration-personnel-procedure-assignment.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

class ConfigurationPersonnelProcedureAssignmentService {
    async create(laboratoryId: number, request: ConfigurationPersonnelProcedureAssignmentCreateRequest): Promise<ConfigurationPersonnelProcedureAssignmentResponse> {
        const response = await axios.post<ConfigurationPersonnelProcedureAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/personnelProcedureAssignments`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationPersonnelProcedureAssignmentResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPersonnelProcedureAssignmentResponse>>(`/configuration/laboratories/${laboratoryId}/personnelProcedureAssignments`, { ...filterModel }, { params })
        return response.data
    }

    async delete(personnelProcedureAssignmentId: number, laboratoryId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/personnelProcedureAssignments/${personnelProcedureAssignmentId}`)
        return response.data
    }
}

export const configurationPersonnelProcedureAssignmentService = new ConfigurationPersonnelProcedureAssignmentService()
